import Link from 'next/link'
import { Crown, PauseCircle } from 'lucide-react'
import { useProTrial, trialDaysRemaining, type ProTrial } from './use-pro-trial'

export function ProTrialCard({ trial, compact = false }: { trial: ProTrial; compact?: boolean }) {
  if (trial.status === 'unavailable') return null
  const days = trialDaysRemaining(trial)
  const expired = trial.status === 'expired' || days === 0
  // Paying members keep their subscription after the earned benefit ends.
  if (expired && trial.isPremium) return null

  return (
    <section aria-label="Trial Pro" className="mb-4 rounded-lg border border-primary/30 bg-card p-4 sm:p-5">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 items-start gap-3">
          {expired ? <PauseCircle aria-hidden="true" className="mt-0.5 size-5 shrink-0 text-muted-foreground" />
            : <Crown aria-hidden="true" className="mt-0.5 size-5 shrink-0 text-primary" />}
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Recompensa da trilha inicial</p>
            <h2 className="mt-1 text-lg font-bold">{expired ? 'Seu trial Pro terminou' : `Pro por mais ${days} ${days === 1 ? 'dia' : 'dias'}`}</h2>
            <p className="mt-1 text-sm text-muted-foreground">
              {expired ? `Você está no plano grátis: até ${trial.freeHabitLimit} hábitos ativos.` : '7 dias de Pro, sem cartão e sem cobrança automática.'}
            </p>
            {!compact || expired ? <p className="mt-2 max-w-prose text-sm text-muted-foreground">
              {expired
                ? 'Os hábitos excedentes ficam pausados. Todos os hábitos e seus históricos continuam salvos. Pause um hábito ativo para reativar outro.'
                : `Ao terminar, os ${trial.freeHabitLimit} hábitos mais antigos continuam ativos e os excedentes ficam pausados. Nada é apagado.`}
            </p> : null}
            {!expired && trial.endsAt ? <p className="mt-2 text-xs text-muted-foreground">Termina em <time dateTime={trial.endsAt}>{new Date(trial.endsAt).toLocaleString('pt-BR')}</time>.</p> : null}
          </div>
        </div>
        <Link href={compact ? '/settings/subscription' : '/manage/habits'} className="inline-flex min-h-11 items-center rounded-md border border-border px-3 text-sm font-semibold hover:bg-accent focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary">
          {compact ? 'Ver meu trial' : 'Gerenciar hábitos'}
        </Link>
      </div>
    </section>
  )
}

export function ProTrialStatus({ compact = false }: { compact?: boolean }) {
  const { data } = useProTrial()
  return data ? <ProTrialCard trial={data} compact={compact} /> : null
}
